export default {
    name: "Save",
    title: "Save",
    icon: "mdi-content-save-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};